import { useCallback } from 'react';
import { debounce } from 'throttle-debounce';

import { EBlockInPageName } from '../../../types/share';
import { trackChartTapOrHover } from '../../../tracking';

export function useOnHover(blockName: EBlockInPageName, isNotDesktop: boolean) {
  return useCallback(
    debounce(250, () => trackChartTapOrHover(blockName, isNotDesktop)),
    [],
  );
}
